import React, { Suspense } from 'react';

export const FinanceSupportComponent = React.lazy(() => import('./FinanceSupport'));

export const FinanceSupport = (props) => (
  <Suspense fallback={null}>
    <FinanceSupportComponent {...props} />
  </Suspense>
);
